import { Spin } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { CanvasPcodeVideoFrameParams } from '../../service/Pcode/PcodeCanvasVideo';
import { PcodeVideoCanvasPreview } from '../PcodeVideoCanvasPreview/PcodeVideoCanvasPreview';

import './GalleryPreviewVideo.css';

export interface GalleryPreviewProps {
    previewSource?: Partial<CanvasPcodeVideoFrameParams>;
}

interface GalleryPreviewVideoState {
    isLoaded: boolean;
    previewSource?: Partial<CanvasPcodeVideoFrameParams>;
}

const BLOCK = 'gallery-preview-video';

export class GalleryPreviewVideo extends React.PureComponent<GalleryPreviewProps, GalleryPreviewVideoState> {
    state: GalleryPreviewVideoState = {
        isLoaded: false
    };

    static getDerivedStateFromProps(nextProps: GalleryPreviewProps, prevState: GalleryPreviewVideoState) {
        const { previewSource } = nextProps;

        if (nextProps.previewSource === prevState.previewSource) {
            return {
                ...prevState
            };
        }

        if (previewSource) {
            // для видео плеера внешний троббер показывает в тот промежуток, когда мы ходит в api за данными для плеера
            // когда данные уже пришли, показ троббера - на совести плеера и внешний троббер мы не показываем
            return { isLoaded: true, previewSource };
        } else {
            return { isLoaded: false, previewSource };
        }
    }

    render() {
        const { previewSource } = this.props;
        const { isLoaded } = this.state;

        return (
            <div
                className={Bem.cls({
                    block: BLOCK,
                    mods: { loaded: isLoaded ? 'yes' : 'no' }
                })}
            >
                {!isLoaded && <Spin cls={Bem.cls(BLOCK, 'spin')} size={'l'} progress={true} />}
                {previewSource && <PcodeVideoCanvasPreview videoPreviewData={previewSource} isAudio={false} />}
            </div>
        );
    }
}
